module.exports = __webpack_public_path__ + "static/media/dot_B605D5.8217a42f.svg";